import {HttpClient} from '@angular/common/http';
import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, OnInit, ViewChild} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {Router} from '@angular/router';
import {faA, faExclamationCircle} from '@fortawesome/free-solid-svg-icons';
import {EventSettingsModel, ScheduleComponent,} from '@syncfusion/ej2-angular-schedule';
import {PopupOpenEventArgs, View} from '@syncfusion/ej2-schedule';
import {SwissAppConfigModels} from 'src/app/models/swissappconfig-models';
import {DatumFormatPipe} from 'src/app/pipes/datum-format.pipe';
import {HelperService} from 'src/app/services/helper.service';
import {LocalStorageService} from '../../local-storage.service';
import {Employees, EmpWorkPlan} from '../models/employees-model';
import {DataService} from '../services/data.service';
import {SharedDataService} from '../services/shared-data.service';
import {IndexedDbData} from 'src/app/time-app/models/indexedDB-model';
import {MatDialog} from '@angular/material/dialog';
import {DailyNotesComponent} from './dailyNotes/dailyNotes.component';
import {EmployeeNoteComponent} from './employeeNote/employeeNote.component';
import {UserAuthenticationService} from '../../services/user-authentication.service';
import {Orders} from '../models/order-model';
import {AppointmentDetailsComponent} from './appointmentDetails/appointment-details.component';
import {ServiceAppService} from '../../services/service-app.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {tap} from 'rxjs';

@Component({
    selector: 'app-share-order', templateUrl: './share-order.component.html', styleUrls: ['./share-order.component.scss'],
})
export class ShareOrderComponent implements OnInit, AfterViewInit {
    faExclamationCircle = faExclamationCircle;
    fa = faA;
    formValue = new UntypedFormControl('');

    public dateFormat: string = 'dd.MM.yyyy';
    public timeFormat: string = 'HH:mm';
    public selectedDate?: Date;
    public data: Record<string, any>[] = [];
    public setView: View = 'Day';
    public plannedEmpWorks: EmpWorkPlan[] = [];
    public currentUser!: Employees;
    public IndexedDbData!: IndexedDbData;
    public eventSettings: EventSettingsModel = {
        allowAdding: false, allowEditing: false, allowDeleting: false, dataSource: this.data,
    };
    public arr = [];
    public displayabledNotes = [];
    public kalenderViewChanged: EventEmitter<string> = new EventEmitter();
    public workerNote: string = '';
    @ViewChild('scheduleObj') public scheduleObj?: ScheduleComponent;
    protected readonly faA = faA;
    private webServiceConfig?: SwissAppConfigModels.WebServiceConfig;
    private noteDialogIsOpen: boolean = false;
    private DEFAULT_START_HOUR: string = '07:00';
    public startHour: string = this.DEFAULT_START_HOUR;
    private DEFAULT_END_HOUR: string = '20:00';
    public endHour: string = this.DEFAULT_END_HOUR;
    private currentCalenderView: string = 'Day';

    constructor(private serviceappservice: ServiceAppService, private changeDetection: ChangeDetectorRef, private router: Router, private shareDataService: SharedDataService, private localStorage: LocalStorageService, private http: HttpClient, private userAuthService: UserAuthenticationService, private helperService: HelperService, public dialog: MatDialog, private _datumFormatPipe: DatumFormatPipe, private dataService: DataService) {
        this.helperService.getSwissWebServiceConfig$().pipe(
            takeUntilDestroyed(),
            tap((config) => {
                this.webServiceConfig = config;
            })
        ).subscribe();
        this.helperService.setPageRefreshURL('/timeapp/share-order').then(() => {
            if (this.userAuthService.getCurrentAuthenticatedUser() == undefined) {
                this.router.navigate(['']);
            }
        });

        this.dataService.getChosenDateAsPromise().then((res) => {
            this.selectedDate = res;
        });
        this.localStorage.get('shareOrderCalendarView', 'SwissWebConfigDB', false, 'Day').then(val => {
            this.currentCalenderView = val;
            this.setView = val;
        });

    }

    ngOnInit() {

    }

    refreshDisplayDates(view: string) {
        let startDate;
        let endDate;
        this.localStorage.add('shareOrderCalendarView', view, 'SwissWebConfigDB');
        switch (view) {
            case 'Day':
                let month = '' + (this.scheduleObj!.activeView.renderDates[0]!.getMonth() + 1);
                if (month.length < 2) {
                    month = '0' + month;
                }
                let date = '' + this.scheduleObj!.activeView.renderDates[0]!.getDate();
                if (date.length < 2) {
                    date = '0' + date;
                }
                const day = this.scheduleObj!.activeView.renderDates[0].getFullYear() + '-' + month + '-' + date + 'T00:00:00';
                startDate = this.scheduleObj!.activeView.renderDates[0].getFullYear() + '-' + month + '-' + date + 'T00:00:00';
                endDate = this.scheduleObj!.activeView.renderDates[0].getFullYear() + '-' + month + '-' + date + 'T23:59:59';
                this.displayabledNotes = this.arr.filter(entry => {
                    return entry['Day'] == day;
                });
                break;
            case 'Week':
            case 'WorkWeek':
            case 'Month':
            default:
                startDate = this.scheduleObj!.activeView.renderDates[0];
                endDate = this.scheduleObj!.activeView.renderDates[this.scheduleObj!.activeView.renderDates.length - 1];
                endDate.setHours(23);
                endDate.setMinutes(59);
                endDate.setSeconds(59);

                this.displayabledNotes = this.arr.filter(entry => {
                    return new Date(entry['Day']) >= startDate && new Date(entry['Day']) <= endDate;
                });
                break;
        }
        let startTime = this.DEFAULT_START_HOUR;
        let endTime = this.DEFAULT_END_HOUR;
        this.startHour = startTime;
        this.endHour = endTime;
        (this.scheduleObj!.eventSettings.dataSource! as any[]).forEach(entry => {
            if (new Date(entry['StartTime']) >= new Date(startDate) && new Date(entry['EndTime']) <= new Date(endDate)) {
                if (entry['StartTime'] && this.getTimeString(entry['StartTime']!) < startTime) {
                    startTime = this.getTimeString(entry['StartTime']!);
                }
                if (entry['EndTime'] && this.getTimeString(entry['EndTime']!) > endTime) {
                    endTime = this.getTimeString(entry['EndTime']!);
                }
            }
        });
        this.startHour = startTime;
        this.endHour = endTime;
        this.changeDetection.markForCheck();
    }

    ngAfterViewInit(): void {
        this.scheduleObj?.selectedDateChange.subscribe({
            next: () => {
                setTimeout(() => this.kalenderViewChanged.emit(this.currentCalenderView || 'Day'), 100);
            }
        });
        this.kalenderViewChanged.subscribe({
            next: (event: any) => {
                this.currentCalenderView = event;
                setTimeout(() => this.refreshDisplayDates(event), 100);
            }
        });
        if (this.selectedDate) {
            this.userAuthService.getUserDayNotes(this.selectedDate.getFullYear() + '-' + (this.selectedDate.getMonth() + 1) + '-' + this.selectedDate.getDate()).then((data) => {
                if (data) {
                    this.arr = data;
                }
            });
        }

        setTimeout(() => {
            this.localStorage.getAllDataFromIndexedDB().then((res: any) => {
                this.IndexedDbData = res;

                const id = this.userAuthService.getCurrentAuthenticatedUser()?.employeeID;
                this.currentUser = this.IndexedDbData.allEmployees.find((el) => el.employeeID === id)!;
                this.formValue.valueChanges.subscribe({
                    next: async (res) => {
                        const pickedEmp = this.IndexedDbData.allEmployees.find((el) => el.employeeID === res);
                        this.reloadWorkerNote('' + res);
                        await this.getEmployeesWorks(pickedEmp!);
                    },
                });
                this.formValue.setValue(this.currentUser.employeeID);

                document.getElementsByClassName('e-toolbar-item e-views e-day')[0].addEventListener('click', () => {
                    this.kalenderViewChanged.emit('Day');
                });

                document.getElementsByClassName('e-toolbar-item e-views e-week')[0].addEventListener('click', () => {
                    this.kalenderViewChanged.emit('Week');
                });

                document.getElementsByClassName('e-toolbar-item e-views e-work-week')[0].addEventListener('click', () => {
                    this.kalenderViewChanged.emit('WorkWeek');
                });

                document.getElementsByClassName('e-toolbar-item e-views e-month')[0].addEventListener('click', () => {
                    this.kalenderViewChanged.emit('Month');
                });

                document.getElementsByClassName('e-toolbar-item e-views e-agenda')[0].addEventListener('click', () => {
                    this.kalenderViewChanged.emit('Agenda');
                });
            });
        }, 100);
    }

    reloadWorkerNote(employeeID: string) {
        this.userAuthService.getWorkerNotes(employeeID).then(note => {
            if (note.length > 0) {
                this.workerNote = note[0].Note;
            }
        });
    }

    getTimeString(value: Date): string {
        return this._datumFormatPipe.transformOnlyTime(value);
    }

    async getEmployeesWorks(employee: Employees) {
        const objCategories = await this.serviceappservice.getObjektKategorien();
        this.getPlannedEmployeeWorksWebCall(employee).subscribe({
            next: (res) => {
                if (!res) {
                    return;
                }
                this.plannedEmpWorks = res;
                this.dataService.getAllOrders().then((res: Orders[]) => {
                    this.IndexedDbData.orders = res;
                    this.data = [];
                    for (const works of this.plannedEmpWorks) {
                        const foundOrder = this.IndexedDbData.orders.find((el) => el.objectID === works.objectID);

                        let a = {
                            rowID: works.rowID,
                            Subject: works.objectNumber + ' ' + works.objDescription,
                            Location: foundOrder?.lastname + (works.note4 ? ' | ' + works.note4 : ''),
                            StartTime: works?.startTime,
                            EndTime: works?.endTime!,
                            Duration: this.getDuration(works),
                            IsAllDay: false,
                            Notes: works.notes,
                            Name: (foundOrder?.anspFirstname?.trim() + ' ' + foundOrder?.anspLastname?.trim()).trim(),
                            Phone: foundOrder?.anspPhone?.trim() ? foundOrder?.anspPhone?.trim() : foundOrder?.phone?.trim(),
                            AnspPhone: foundOrder?.anspPhone03.trim(),
                            Category: works.fK_EmpWorkPlanCategoryID ? objCategories.find(cat => cat.id == works.fK_EmpWorkPlanCategoryID) : undefined,
                            serviceID: works.serviceID,
                            projectLeader: foundOrder?.projectLeader

                        }
                        this.data.push(a);
                    }
                    this.scheduleObj!.eventSettings.dataSource = this.data;
                    this.changeDetection.markForCheck();
                    this.localStorage.get('shareOrderCalendarView', 'SwissWebConfigDB', false, 'Day').then((val) => {
                        setTimeout(() => this.refreshDisplayDates(val), 100);
                    });
                });
            }
        });
    }

    isLightColor(hexcolorstring) {
        if (hexcolorstring) {
            const c = hexcolorstring.substring(1);      // strip #
            const rgb = parseInt(c, 16);   // convert rrggbb to decimal
            const r = (rgb >> 16) & 0xff;  // extract red
            const g = (rgb >> 8) & 0xff;  // extract green
            const b = (rgb >> 0) & 0xff;  // extract blue
            const luma = r * 0.299 + g * 0.587 + b * 0.114;
            return (luma >= 128) ? 'black' : 'white';
        }
        return 'white';
    }

    getDuration(works: EmpWorkPlan) {
        if (works && works.startTime && works.endTime) {
            return this._datumFormatPipe.ouersBetweenToStringDates(works.startTime, works.endTime);
        }
        return 1;
    }

    showDailyNotes() {
        this.dialog.open(DailyNotesComponent, {
            disableClose: false, data: this.displayabledNotes, panelClass: 'swissdefault-dialog-container',
        });
    }

    showEmployeeNote() {
        this.dialog.open(EmployeeNoteComponent, {
            disableClose: false, data: this.workerNote, panelClass: 'swissdefault-dialog-container',
        });
    }

    showDetails(event: any, notes: any) {
        event.preventDefault();
        if (event.srcEvent) {
            event.srcEvent.stopPropagation();
            event.srcEvent.stopImmediatePropagation();
        }

        this.noteDialogIsOpen = true;
        let dialogRef = this.dialog.open(AppointmentDetailsComponent, {
            disableClose: false, data: notes, panelClass: 'swissdefault-dialog-container',
        });

        return dialogRef.afterClosed().subscribe({
            next: () => {
                this.noteDialogIsOpen = false;
            },
        });
    }

    getCaseValue(duration: number) {
        let result = 4;
        if (duration <= 0.25) {
            return 1; // Es wird nur eine Zeile angezeigt
        } else if (duration <= 0.5) {
            return 2; // Es werden nur zwei Zeilen angezeigt
        } else if (duration <= 0.75) {
            return 3; // Es werden nur zwei Zeilen angezeigt
        }
        return result; // Es werden vier Zeilen oder mehr angezeigt
    }

    getIconStyle(value: number): Object {
        if (value === 1) {
            return {color: 'red', 'margin-top': '-8px'};
        } else if (value === 2) {
            return {color: 'red', 'margin-top': '-4px'};
        }
        return {};
    }

    getPlannedEmployeeWorksWebCall(emp: any) {
        const url = this.webServiceConfig!.tishUrl;
        return this.http.get<EmpWorkPlan[]>(`${url}/GetPlannedEmployeeWorks?EmployeeID=${emp?.employeeID}&MandantID=${this.userAuthService.getCurrentAuthenticatedUser()?.mandatorID}`, {
            headers: {
                'Content-Type': 'application/json', Authorization: `${this.helperService.getSwissAuthorization(this.userAuthService.currentUserInfo)}`,
            },
        });
    }

    onPopupOpen(args: PopupOpenEventArgs) {
        args.cancel = true;
    }

    async goBack() {
        await this.router.navigateByUrl('/timeapp');
    }

    shareIndexDb() {
        this.shareDataService.shareIndexedDB(this.IndexedDbData);
    }

    picked(event: any) {
        if (this.noteDialogIsOpen) {
            return;
        }
        const foundPlannedWork = this.plannedEmpWorks.find((el) => el.rowID === event.event.rowID);
        this.shareDataService.changeMessage(foundPlannedWork, 'shareOrder');
        this.router.navigateByUrl('/timeapp');
        this.shareIndexDb();
    }

    onEventRendered(ev: any) {
        const bg = ev.data?.Category?.hexColor || ev.data.PrimaryColor;
        ev.element.style.backgroundColor = bg;
        if ((ev.element as HTMLElement).classList.contains('e-agenda-view')) {
            ev.element.style.color = 'black';
        } else {
            ev.element.style.color = this.isLightColor(bg);
        }
    }
}
